import { useTranslation } from 'react-i18next'

import { QA_SECTION_KEY } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import Text from '../../Text'

import { QA_NAME_SETTINGS_SECTION } from './SettingsSection.constants'

import * as styles from './SettingsSection.module.css'

function SettingsSection({
  Buttons,
  buttonsProps,
  children,
  className = styles.SettingsSection,
  description,
  headerClassName = styles.header,
  qaName,
  title,
}) {
  const { t } = useTranslation()

  const qaProps = getQaSelector(
    { def: QA_NAME_SETTINGS_SECTION, value: qaName },
    QA_SECTION_KEY
  )

  return (
    <section {...qaProps} className={className}>
      <div className={headerClassName}>
        <div className={styles.titleContainer}>
          {title ? (
            <Text Element='h3' className={styles.title}>
              {t(title)}
            </Text>
          ) : null}
          {Buttons ? <Buttons {...buttonsProps} /> : null}
        </div>
        {description ? (
          <Text Element='p' className={styles.description}>
            {t(description)}
          </Text>
        ) : null}
      </div>
      {children}
    </section>
  )
}

export default SettingsSection
